import React, { useState } from 'react';
import './PricingPlans.css';

const PricingPlans = ({ plansData }) => {
  const [selectedUserOptions, setSelectedUserOptions] = useState(
    plansData.map(() => 0)
  );

  const handleUserOptionChange = (planIndex, optionIndex) => {
    const newSelections = [...selectedUserOptions];
    newSelections[planIndex] = optionIndex;
    setSelectedUserOptions(newSelections);
  };

  return (
    <div className="container my-5 princing" >
      <div className="text-center">
        <h1 className="mb-3 " >Choisissez votre pack email</h1>
        <p>Flexible: ajoutez des boîtes email supplémentaires à tout moment, en fonction de vos besoins !</p>
      </div>
      <div className="row justify-content-center">
        {plansData.map((plan, index) => (
          <div key={plan.id} className="col-md-6">
            <div className={`card pricing-card ${plan.discount ? 'highlighted-card' : ''}`}>
              <div className="card-body">
                <h3 className="card-title">{plan.title}</h3>
                <div className="row g-4">
                  <div className="col-8">
                    <p className="card-text">
                      <br />
                      {plan.emails}

                    </p>
                  </div>
                  <div className="col-4">
                    {/* Prix dynamique si options disponibles */}
                    <h3 className="price">
                      {plan.priceOptions
                        ? `${plan.priceOptions[selectedUserOptions[index]]}$`
                        : `${plan.price} XAF`}<span className="price-info">
                        /mois
                      </span>
                    </h3>
                    
                  </div>
                </div>
                <hr />
                <a
                  className="btn-outline-primary"
                  href={`mailto:contact@visibilitycam.com?subject=Commande ${plan.title}&body=Bonjour,%0D%0AJe souhaite commander le plan "${plan.title}" avec ${plan.emails}.%0D%0AOption utilisateur: ${plan.usersOptions ? plan.usersOptions[selectedUserOptions[index]] : 'Standard'}%0D%0APrix: ${plan.priceOptions ? plan.priceOptions[selectedUserOptions[index]] + '$' : plan.price + ' XAF'}%0D%0AMerci.`}
                >
                  Commander ↗
                </a>




                {/* Options utilisateurs (si présentes) */}
                {plan.usersOptions && (
                  <div className="dropdown mt-3">
                    <select
                      className="form-select"
                      onChange={(e) => handleUserOptionChange(index, e.target.value)}
                    >
                      {plan.usersOptions.map((option, optionIndex) => (
                        <option key={optionIndex} value={optionIndex}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {/* Liste des fonctionnalités */}
                <ul className="feature-list mt-3">
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingPlans;
